import { TreeFormData } from '../TreeFormData';

export function getDefaultNodeName(data: TreeFormData) {
  const someName = data.names?.find((o) => o.name && o.name.length > 0)?.name;
  return someName ?? data.typeSelected$?.value?.name ?? data?.item?.item_name ?? '';
}
